export default __webpack_public_path__ + "static/media/coaches_introduction.723f85ee.png";